import { render } from "./icon-block.vue?vue&type=template&id=3cb194ed"
import script from "./icon-block.vue?vue&type=script&lang=js"
export * from "./icon-block.vue?vue&type=script&lang=js"

import exportComponent from "/mobefind/web/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__